import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import OfferCarouselContainer from 'partial/OfferManager/OfferCarouselContainer';

const OcfOffersTemplateModuleView = props => {
  return (
    <>
      <SectionContainer>
        <Row>
          <FlexContainer className={'flex-column'}>
            <Label className={'H4'}>{props.cardsContainerConfig?.title}</Label>
            {props.cardsContainerConfig?.subTitle && (
              <Label className={'Body-1 margT16'}>
                {props.cardsContainerConfig?.subTitle}
              </Label>
            )}
          </FlexContainer>
        </Row>
        <Row type="carousel">
          <OfferCarouselContainer
            {...props}
            offers={props?.offers}
            pagePosition={props?.moduleName}
            modulePosition={props?.modulePosition}
            maxOffers={props?.cardsContainerConfig?.maxOffers}
          />
        </Row>
      </SectionContainer>
    </>
  );
};

export default OcfOffersTemplateModuleView;
